import { combineReducers } from 'redux';
import ui from './ui';
import control from './control';
import exerciseCheck from './exerciseCheck';
import niceAudio from './niceAudio';
import rectify from './rectify';
import logoutReason from './logout';
import token from './token';
import gene from './gene';
import achievementMes from './achievementMes';

const combinedReducer = combineReducers({
  ui,
  control,
  exerciseCheck,
  niceAudio,
  rectify,
  logoutReason,
  token,
  gene,
  achievementMes
});

export default combinedReducer;
